<template>
  <vetalfa-dialog
    v-on:dialogClose="
      () => {
        setClickedReferences([]);
        referencesModel = false;
      }
    "
    :title="_getLabel('REFERENCES')"
    :toggleModel="referencesModel"
    :featureMode="false"
  >
    <template v-slot:tabs>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="#193153 !important"
        centered
        height="50px"
        class="mt-2"
        fixed-tabs
      >
        <v-tab
          class="text-none"
          v-for="item in tabs"
          :key="`ref-${item}`"
          @click="
            $vuetify.goTo(0, {
              duration: 0,
              offset: 0,
              easing: 'easeInOutCubic',
            })
          "
        >
          <span class="">{{ item }}</span>
        </v-tab>
      </v-tabs>
    </template>
    <div v-for="reference in filteredReferences" :key="reference.name">
      <vetalfa-reference-card :reference="reference"></vetalfa-reference-card>
    </div>
  </vetalfa-dialog>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ReferencesDialog",
  computed: {
    ...mapGetters("topics", ["clickedReferences"]),
    filteredReferences() {
      let arr = [];
      this.clickedReferences.forEach((r) => {
        let hasRef = !!arr.find((i) => {
          return i.name === r.name;
        });
        if (
          !hasRef &&
          (this.tabs.length == 1 ||
            (this.tab == 0 && r.type === 1) ||
            (this.tab == 1 && !r.type))
        ) {
          arr.push(r);
        }
      });
      return arr;
    },
    tabs() {
      let arr = [];
      if (
        this.clickedReferences.filter((c) => {
          return c.type == 1;
        }).length > 0
      ) {
        arr.push("Vet Alfa");
      }
      if (
        this.clickedReferences.filter((c) => {
          return !c.type;
        }).length > 0
      ) {
        arr.push(this._getLabel("EXTERNAL"));
      }
      return arr;
    },
  },
  watch: {
    clickedReferences(val) {
      if (val.length) {
        this.referencesModel = true;
      }
    },
  },
  methods: {
    ...mapMutations("topics", ["setClickedReferences"]),
  },
  data() {
    return {
      referencesModel: false,
      tab: 0,
    };
  },
};
</script>
